export const TRAINING_STATUSES = ['Planned', 'In progress', 'Completed', 'Cancelled'];

/**
 * Kodet rrinë në anglisht, teksti në shqip.
 *
 * `trainings.status` dhe `trainings.type` ruhen si kode ('Planned',
 * 'Mandatory') dhe mbahen nga një CHECK në bazë — ato nuk përkthehen. Por deri
 * tani ato kode dilnin drejt e në ekran: regjistri i trajnimeve, i vetmi
 * dokument që një auditor i punës do ta lexonte, tregonte «Mandatory» dhe
 * «In progress» mes tekstit shqip. Ky është vetëm shtresa e ekranit; një kod i
 * panjohur kthehet ashtu siç është, që një vlerë e re të mos dalë bosh.
 */
/**
 * Kërkimi është i pandjeshëm ndaj shkronjave të mëdha.
 *
 * Baza i ka të dyja format — «In progress» nga formulari dhe «In Progress» nga
 * të dhënat e hershme. Me krahasim të saktë, e dyta binte te dega e panjohur
 * dhe dilte ashtu siç ishte: një etiketë anglisht mes atyre shqip.
 */
const labelFrom = (map) => {
  const lower = Object.fromEntries(Object.entries(map).map(([k, v]) => [k.toLowerCase(), v]));
  return (code) => lower[String(code || '').toLowerCase()] || code || '—';
};

export const TRAINING_STATUS_LABELS = {
  'Planned':     'Planifikuar',
  'In progress': 'Në vazhdim',
  'Completed':   'Përfunduar',
  'Cancelled':   'Anuluar',
};
export const trainingStatusLabel = labelFrom(TRAINING_STATUS_LABELS);

// Pa nyjë: «I detyrueshëm» pritej me tri pika brenda çipit të kolonës, dhe një
// etiketë e prerë nuk e thotë dot ndryshimin mes të detyrueshmes dhe tjetrës.
export const TRAINING_TYPE_LABELS = {
  'Mandatory':   'Detyrueshëm',
  'Recommended': 'Rekomanduar',
  'Optional':    'Opsional',
};

export const trainingTypeLabel = labelFrom(TRAINING_TYPE_LABELS);

export const PARTICIPANT_STATUS_LABELS = {
  'Not started': 'Pa filluar',
  'In progress': 'Në vazhdim',
  'Completed':   'I përfunduar',
  'Failed':      'I pakaluar',
};
export const participantStatusLabel = labelFrom(PARTICIPANT_STATUS_LABELS);

export const INVITE_STATUS_LABELS = {
  'Pending':  'Në pritje',
  'Sent':     'Dërguar',
  'Accepted': 'Pranuar',
};
export const inviteStatusLabel = labelFrom(INVITE_STATUS_LABELS);
/**
 * Lloji i financimit — KOD + etiketë, pasqyrim i backend/config/trainingFunding.js.
 * Ruhet kodi (`trainings.funding_type`, CHECK në bazë); etiketa është vetëm për ekran.
 */
export const TRAINING_FUNDING_TYPES = [
  { code: 'COMPANY', label: 'Paguhet nga kompania' },
  { code: 'PARTNER', label: 'Paguhet nga partneri' },
  { code: 'FREE',    label: 'Pa pagesë' },
];
export const DEFAULT_FUNDING_TYPE = 'COMPANY';
export const fundingLabel = (code) => (TRAINING_FUNDING_TYPES.find((t) => t.code === code) || {}).label || code || '';
export const TRAINING_TYPES = ['Mandatory', 'Recommended'];
export const TRAINING_DEPARTMENTS = ['Finance', 'HR', 'IT', 'Sales'];
export const PARTICIPANT_STATUSES = ['Not started', 'In progress', 'Completed', 'Failed'];
export const INVITE_STATUSES = ['Pending', 'Sent', 'Accepted'];
